import { ModalButton } from '@philips-internal/oswald-ui-components';

export enum DialogType {
  ACTION = 'action',
  ALERT = 'alert',
  AWAIT = 'await'
}

export enum ModalType {
  DEFAULT = 'default',
  DIALOG = 'dialog',
  FULL_SCREEN = 'fullscreen'
}

export interface SimpleDialogParams {
  buttons?: ModalButton[];
  closeable: boolean;
  descriptionDialog?: string;
  dialogType: DialogType;
  fragment?: string;
  modalType: ModalType;
  onClickCancel?: () => void;
  onClickOk?: () => void;
  titleDialog: string;
  titleOnCancel?: string;
  titleOnOk: string;
}